import { useMemo } from 'react';
import { UploadDetail } from '../../../../services/entities/impl/blfApi/schemas/uploadSummary';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { TooltipGenericInfo } from '../../../commonUI/tooltips/TooltipGenericInfo';
type Props = {
  collectionId: string;
  uploadDetail?: UploadDetail;
};

/**
 * Tooltip component that displays upload details if provided,
 * or just collection ID if no upload details are available
 */
export const TooltipUploadDetail = ({ collectionId, uploadDetail }: Props) => {
  const { t } = useTranslation();

  // Format upload details with descriptive labels or fall back to collection ID
  const items = useMemo(() => {
    if (uploadDetail) {
      return [
        {
          label: t('Collection ID'),
          value: uploadDetail.collectionID || collectionId,
        },
        {
          label: t('Collection Date'),
          value: uploadDetail.collectionDate || '',
        },
        {
          label: t('Camera ID'),
          value: uploadDetail.cameraID || '',
        },
        {
          label: t('SSD ID'),
          value: uploadDetail.ssdID || '',
        },
        {
          label: t('Upload Progress'),
          value: `${uploadDetail.percentUploaded}%`,
          showCopyButton: false,
        },
        {
          label: t('Status'),
          value: uploadDetail.status || '',
        },
        {
          label: t('Upload Started'),
          value: uploadDetail.uploadStartedAt || '',
        },
        {
          label: t('Latest File Uploaded'),
          value: uploadDetail.latestFileUploadedAt || '',
        },
      ];
    } else {
      // If no uploadDetail provided, just show the collection ID
      return [
        {
          label: t('Collection ID'),
          value: collectionId,
        },
      ];
    }
  }, [uploadDetail, collectionId, t]);

  return (
    <TooltipGenericInfo
      title={uploadDetail ? t('Upload Detail') : t('Collection Information')}
      items={items}
    />
  );
};
